export default "__VITE_ASSET__A$kkKey8__"